@if (projectOutcome) {
  <div class="outcome">
    <div class="row">
      <div class="col-md-12 outcome-detail-panel">
        <div class="number-panel">
          <div>
            <span class="btn hub-round-button rounded-round btn-icon btn-sm legitRipple mr-3">
              <span class="letter-icon">{{indexOffset + outcomeIndex}}</span>
            </span>
          </div>
        </div>
        <div class="left-panel">
          <div class="title">
            <div class="hub-unique-id-panel">
              <span class="hub-unique-id">{{projectOutcome.customOutcome.uniqueId}}</span>
            </div>
            <h5 class="non-sca-outcome-metric">
              <span class="font-weight-bold">
                Outcome -
              </span> {{projectOutcome.customOutcome.indicatorName}} <span
            class="text-muted font-size-sm">({{projectOutcome.customOutcome.unit}})</span>
          </h5>
        </div>
        @if (projectOutcome.isPolicyLeverageOutcome) {
          <div class="mt-1 mb-1">
            <span class="font-weight-bold" style="color: #018899;">Leverage Outcome: </span>
            <span class="text-muted">Policy</span>
          </div>
        }
        <p class="record-description">{{projectOutcome.statement}}</p>

        @if (projectOutcome.customOutcome.parentCustomOutcomes.length) {
            @for (parentCustomOutcome of projectOutcome.customOutcome.parentCustomOutcomes; track parentCustomOutcome.parentCustomOutcomeId) {
                <div class="text-indigo-300" style="margin-bottom: 20px;">
                    <i class="align-baseline mr-1 icon-tree7"></i>
                    <span class="font-weight-bold">{{'Linked to: '}}</span>
                    <span>Strategy Custom Outcome </span>
                    <span class="font-weight-bold">{{'CM' + parentCustomOutcome.customOutcomeId + ' '}}</span>
                    <span>{{parentCustomOutcome.parentCustomOutcomeProjectName}}</span>
                </div>
            }
        }

    </div>
    <div class="right-panel">
      <div>
        @if (projectOutcome.outcomeStatistics.hasTargets || projectOutcome.outcomeStatistics.hasProgress) {
          <div
            >
            <mat-checkbox [(ngModel)]="areDetailsShowing" color="primary">Show Details</mat-checkbox>
          </div>
        }
        <!-- PROGRESS BAR -->
        @if (projectOutcome.outcomeStatistics.hasTargets) {
          <div>
            <div class="progress mt-1 mb-2" style="height: 0.5rem;">
              <div class="progress-bar bg-success"
                [style.width.%]="projectOutcome.outcomeStatistics.totalProgressPercent * 100">
              </div>
            </div>
            @if (projectOutcome.outcomeStatistics.lastTargetValue !== 0) {
              <div>
                <span class="font-weight-bold">
                {{projectOutcome.outcomeStatistics.totalProgressPercent | percent}}</span> achieved
                towards target of
                <span class="font-weight-bold">{{projectOutcome.outcomeStatistics.lastTargetValue | number:
                  '0.0-0'}}
                {{projectOutcome.customOutcome.unit}}</span>
              </div>
            }
          </div>
        }
        @if (!projectOutcome.customOutcome.isCalculatedAsRate) {
            <div style="margin-top: 10px;" [innerHtml]="getCurrentPeriodProgressInfo(projectOutcome)">
            </div>
        }
      </div>
    </div>
  </div>
</div>
<!-- OUTCOME TABLE -->
<!--Metric Values-->
@if (areDetailsShowing) {
  <div class="row outcomeTarget pl-5 pr-3" #detailsPanel>
    @if (!detailsLoading) {
      <div class="col-md-12">
        <h5 class="text-success">Outcome Start, Progress and Target Values</h5>
        <div class="table-responsive mb-2">
          <table class="table table-bordered table-border-dashed metric-table">
            <thead>
              <tr class="table-border-double">
                <th class="text-right" width="5%">ID</th>
                <th width="20%" class="text-right">Value Type</th>
                <th width="30%" class="text-right">Date</th>
                <th class="text-right">Value</th>
              </tr>
            </thead>
            @for (target of projectOutcome.targets; track target) {
              <tbody>
                <tr>
                  <td class="text-right">
                    <div class="hub-unique-id-panel">
                      <span class="hub-unique-id">{{target.uniqueId}}</span>
                    </div>
                  </td>
                  <td class="text-right">
                    <span class="date-label text-success">Target</span>
                  </td>
                  <td class="text-right">
                    <span class="d-block">
                      {{target.targetDate | date}}
                    </span>
                  </td>
                  <td class="text-right">
                    <span class="value">
                      {{target.targetValue | number: '1.0-3'}}
                    </span>

                    <span class="unit">
                      {{projectOutcome.customOutcome.unit}}
                    </span>
                  </td>
                </tr>
              </tbody>
            }
            @for (outcomeProgress of cummulativeProgress; track outcomeProgress) {
              <tbody>
                @if (!outcomeProgress.isStart) {
                  <tr>
                    <td class="text-right">
                      <div class="hub-unique-id-panel">
                        <span class="hub-unique-id">{{outcomeProgress.uniqueId}}</span>
                      </div>
                    </td>
                    <td class="text-right">
                      <span class="date-label text-dark">Progress</span>
                    </td>
                    <td class="text-right">
                      <span class="d-block">
                        {{outcomeProgress.progressDate | date}}
                      </span>
                    </td>
                    <td class="text-right">
                      <span class="value">
                        {{outcomeProgress.progressValue | number: '1.0-3'}}
                      </span>
                      <span class="unit">
                        {{projectOutcome.customOutcome.unit}}
                      </span>
                      @if (isStrategy) {
                        <div class="mt-1">
                          <a class="badge-primary badge font-size-lg"
                          [routerLink]="'/portfolio/' + outcomeProgress.childProjectId">{{outcomeProgress.childProjectName}}</a>
                        </div>
                      }
                      @if (!isStrategy) {
                        <div>
                          <div class="attribution">
                            <span>{{outcomeProgress.attributionLevel?.name}}</span>
                          </div>
                          <div class="attribution-text">
                            {{outcomeProgress.attributionDescription}}
                          </div>
                        </div>
                      }
                    </td>
                  </tr>
                }
                @if (outcomeProgress.isStart) {
                  <tr>
                    <td class="text-right">
                      <div class="hub-unique-id-panel">
                        <span class="hub-unique-id">{{outcomeProgress.uniqueId}}</span>
                      </div>
                    </td>
                    <td class="text-right">
                      <span class="date-label text-primary">Start</span>
                    </td>
                    <td class="text-right">
                      <span class="d-block">
                        {{outcomeProgress.progressDate | date}}
                      </span>
                    </td>
                    <td class="text-right">
                      <span class="value">
                        {{outcomeProgress.progressValue | number: '1.0-3'}}
                      </span>
                      <span class="unit">
                        {{projectOutcome.customOutcome.unit}}
                      </span>
                      @if (isStrategy) {
                        <div class="mt-1">
                          <a class="badge-primary badge font-size-lg"
                          [routerLink]="'/portfolio/' + outcomeProgress.projectId">{{outcomeProgress.projectName}}</a>
                        </div>
                      }
                      @if (!isStrategy) {
                        <div>
                          <div class="attribution">
                            <span>{{outcomeProgress.attributionLevel?.name}}</span>
                          </div>
                          <div class="attribution-text">
                            {{outcomeProgress.attributionDescription}}
                          </div>
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
      </div>
    }
    @if (detailsLoading) {
      <app-modal-spinner></app-modal-spinner>
    }
  </div>
}
</div>
}
